// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SalesPersonCard, { SalesPersonCardStyles } from "@werner/App/Components/MiniMyAccount/SalesPersonCard";
import React from "react";
import { css } from "styled-components";

export const enum fields {
    title = "title",
    type = "type",
}
interface SalesPersonInfoProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.type]: "inside" | "outside";
    };
}
type Props = SalesPersonInfoProps;

interface SalesPersonInfoStyles {
    container?: InjectableCss;
    salesPersonCard?: SalesPersonCardStyles;
}
export const salesPersonInfoStyles: SalesPersonInfoStyles = {
    salesPersonCard: {
        title: {
            variant: "h5",
            size: 24,
            weight: 500,
            css: css`
                letter-spacing: 0;
                line-height: 27px;
                margin-bottom: 12px;
            `,
        },
    },
};

const styles = salesPersonInfoStyles;

const SalesPersonWidget: React.FC<Props> = ({ fields: { title, type }, id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-id="sales-person-info">
            <SalesPersonCard title={title} salesPersonType={type} extendedStyles={styles.salesPersonCard} />
        </StyledWrapper>
    );
};
export const definition: WidgetDefinition = {
    group: "Xngage Custom" as any,
    icon: "info",
    fieldDefinitions: [
        {
            displayName: "Title",
            name: fields.title,
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
        },
        {
            displayName: "Sales Person Type",
            name: fields.type,
            defaultValue: "outside",
            fieldType: "General",
            editorTemplate: "RadioButtonsField",
            options: [
                {
                    displayName: "Outside Rep",
                    value: "outside",
                },
                {
                    displayName: "Inside Rep",
                    value: "inside",
                },
            ],
        },
    ],
};
const widgetModule: WidgetModule = {
    component: SalesPersonWidget,
    definition,
};
export default widgetModule;
